
import firebase from "firebase";
firebase.initializeApp({
    apiKey: "AIzaSyAlJXpgoEr-MVqd_OQHeaL1hh2FFP3ZBxk",
    authDomain: "fragranciabd20.firebaseapp.com",
    projectId: "fragranciabd20",
    storageBucket: "fragranciabd20.appspot.com",
    messagingSenderId: "836519718922",
    appId: "1:836519718922:web:1d47cfae154fbca9422ff3",
    measurementId: "G-PNDPE9YRJE"
});
const db = firebase.firestore();
// make sure we use the emulator db if on localhost
export default db;
// export const rdb = firebase.database();
// export const auth = firebase.auth;
// export const storage = firebase.storage();